
import { ListButton } from 'react-admin';
import ArrowBack from '@material-ui/icons/ArrowBack';

export const BackToProfile = ({userID}:{userID: string}): JSX.Element => {
  return(
    <ListButton to={{pathname: `/profiles/${userID}/show/addresses`}}  label={'Back to profile'} icon={<ArrowBack/>}/>
  )};
